module.exports = __webpack_public_path__ + "static/media/pap.5bc131e1.png";